import { render } from "./BadgesCreating.vue?vue&type=template&id=5ce94e9a&ts=true"
import script from "./BadgesCreating.vue?vue&type=script&lang=ts"
export * from "./BadgesCreating.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__